/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Discard_BodyInputs */

const en_us2_offline_discard_body = /** @type {(inputs: Offline_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It will not be sent, and it cannot be brought back.`)
};

const pt_br2_offline_discard_body = /** @type {(inputs: Offline_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele não será enviado e não dá para recuperar.`)
};

const es_419_offline_discard_body = /** @type {(inputs: Offline_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se enviará y no se puede recuperar.`)
};

const pt_pt2_offline_discard_body = /** @type {(inputs: Offline_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não será enviado e não há forma de o recuperar.`)
};

const fr_fr2_offline_discard_body = /** @type {(inputs: Offline_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle ne sera pas envoyée et ne pourra pas être récupérée.`)
};

const de_de2_offline_discard_body = /** @type {(inputs: Offline_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er wird nicht gesendet und lässt sich nicht wiederherstellen.`)
};

const it_it2_offline_discard_body = /** @type {(inputs: Offline_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non verrà inviata e non si potrà recuperare.`)
};

/**
* | output |
* | --- |
* | "It will not be sent, and it cannot be brought back." |
*
* @param {Offline_Discard_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_discard_body = /** @type {((inputs?: Offline_Discard_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Discard_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_discard_body(inputs)
	if (locale === "es-419") return es_419_offline_discard_body(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_discard_body(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_discard_body(inputs)
	if (locale === "de-DE") return de_de2_offline_discard_body(inputs)
	if (locale === "it-IT") return it_it2_offline_discard_body(inputs)
	return en_us2_offline_discard_body(inputs)
});
export { offline_discard_body as "offline.discard_body" }